import api from '@/utils/http'

/**
 功能：列表
 time: 2025-13-01 17:13:44
 **/
export function getCompanyTypeList(data) {
    return api.post('/admin/companyType/getList', data)
}

/**
 功能：保存
 time: 2025-38-02 16:38:38
 **/
export function saveCompanyType(data) {
    return api.post('/admin/companyType/eSave', data)
}

/**
 功能：
 time: 2025-42-02 16:42:10
 **/
export function getCompanyTypeDetail(type_id) {
    return api.post('/admin/companyType/getDetail', { type_id: type_id })
}

/**
 功能：
 time: 2025-20-02 17:20:52
 **/
export function deleteCompanyType(type_id) {
    return api.post('/admin/companyType/del', {type_id: type_id})
}

/**
 功能：
 time: 2025-48-03 09:48:06
 **/
export function deleteAllCompanyType(typeIds) {
    return api.post('/admin/companyType/delAll', {typeIds: typeIds})
}

/**
 功能：下拉
 time: 2025-49-03 09:49:03
 **/
export function selectCompanyTypeList() {
    return api.get('/admin/companyType/getSelectList')
}

